module.exports = __webpack_public_path__ + "static/media/chorthippus_pullus_Balz_005_APA.09039044.mp3";